import type {
  SeedGroupDetail,
  SeedGroupDetailResponse,
  SeedGroupList,
  SeedGroupListEnvelope,
  SeedGroupRowResponse,
  SeedGroupStats,
  SeedGroupStatsResponse,
  SeedGroupSummary,
} from '../types';

export function groupMapper(row: SeedGroupRowResponse): SeedGroupSummary {
  return {
    id: row.id,
    name: row.name,
    // `null` stays `null`: the editor shows an empty field, never the string "null".
    description: row.description ?? null,
    memberCount: row.member_count,
    // Derived by the server from the member addresses, the same rule the seeds list uses.
    ispMix: row.isp_mix,
    updatedAt: row.updated_at,
  };
}

export function groupDetailMapper(row: SeedGroupDetailResponse): SeedGroupDetail {
  return { ...groupMapper(row), seedIds: row.seed_ids ?? [] };
}

export function groupStatsMapper(stats: SeedGroupStatsResponse): SeedGroupStats {
  return {
    groupCount: stats.group_count,
    groupedSeedCount: stats.grouped_seed_count,
    ungroupedSeedCount: stats.ungrouped_seed_count,
  };
}

export function groupListMapper(envelope: SeedGroupListEnvelope): SeedGroupList {
  return {
    groups: envelope.data.map(groupMapper),
    total: envelope.total,
    limit: envelope.limit,
    offset: envelope.offset,
    lastItemIdentifier: envelope.last_item_identifier,
    stats: groupStatsMapper(envelope.stats),
  };
}
